import { ArrowRight, Building2, MapPinned, SearchCheck, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const TRUST_CARDS = [
  {
    key: "cleaner-listings",
    icon: SearchCheck,
    title: "Cleaner listings, less noise",
    body: "Spend less time sorting through clutter and more time focusing on real opportunities that deserve attention.",
  },
  {
    key: "real-advisors",
    icon: ShieldCheck,
    title: "Direct access to real advisors",
    body: "Move from browsing to a real conversation faster with clearer contact paths and less friction.",
  },
  {
    key: "district-perspective",
    icon: MapPinned,
    title: "Better district and market perspective",
    body: "Understand how location, pricing, and timing fit together before you decide what to do next.",
  },
  {
    key: "faster-next-steps",
    icon: Building2,
    title: "Faster next steps from search to enquiry",
    body: "Search, shortlist, request guidance, and move into action from one coordinated property flow.",
  },
];

export const ConsumerTrustSection = ({ buildBrandedPath }) => (
  <section className="section-shell pt-8" data-testid="homepage-consumer-trust-section">
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]">Why SGPropPortal for End Users</p>
        <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#001935] md:text-5xl" data-testid="homepage-consumer-trust-heading">
          A cleaner property journey for buyers, tenants, sellers, and landlords.
        </h2>
        <p className="mt-4 text-sm leading-8 text-[#42566f] md:text-base" data-testid="homepage-consumer-trust-copy">
          SGPropPortal is designed to make decisions easier, reduce wasted clicks, and connect you to the right next step faster.
        </p>
      </div>

      <Link className="outline-button" data-testid="homepage-consumer-trust-contact-button" to={buildBrandedPath("/contact")}>
        Contact Us <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </div>

    <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-testid="homepage-consumer-trust-grid">
      {TRUST_CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <div className="rounded-[28px] border border-[#D7C39A]/36 bg-[#FFFDF7] p-6 shadow-[0_18px_50px_rgba(12,40,90,0.05)]" data-testid={`homepage-consumer-trust-card-${card.key}`} key={card.key}>
            <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#D7C39A]/36 bg-[#FFF4DB] text-[#8b6d16]">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-5 text-2xl font-semibold leading-tight text-[#0C285A]">{card.title}</h3>
            <p className="mt-4 text-sm leading-7 text-[#42566f]">{card.body}</p>
          </div>
        );
      })}
    </div>
  </section>
);